import { Grid, GridRow, Input, ModalBottomButtons } from '@bp/ui-components';
import { Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-router-dom';
import { SubstitutionDataEntry } from '../../../pages/Substitutions/Plan/PlanSubstitutions/utils';
import styles from './DifferentTimeForm.module.scss';

type DifferentTimeFormType = {
  comment: string;
};

type DifferentTimeProps = {
  originTeachers: SubstitutionDataEntry[];
  originRooms: SubstitutionDataEntry[];
  onLoad: (loading: boolean) => void;
  onClose: () => void;
};

export const DifferentTimeForm = ({ originTeachers, originRooms, onLoad, onClose }: DifferentTimeProps) => {
  const { t } = useTranslation();

  const initialValues: DifferentTimeFormType = {
    comment: '',
  };

  async function handleSubmit(values: DifferentTimeFormType, formHelpers: FormikHelpers<DifferentTimeFormType>) {
    onLoad(true);
    // TODO: implement
    onLoad(false);
    onClose();
  }

  return (
    <Formik<DifferentTimeFormType> initialValues={initialValues} onSubmit={handleSubmit}>
      {({ setFieldValue, values, isSubmitting, dirty, resetForm }) => {
        return (
          <Form className={styles['different-time-form']}>
            <div className={styles.info}>
              <div>
                {t('substitutions.initialTeacher')}:
                <span className={styles.bold}>
                  {originTeachers.length > 0 ? originTeachers.map((t) => t.name).join(', ') : t('common.none')}
                </span>
              </div>
              <div>
                {t('substitutions.initialRooms')}:
                <span className={styles.bold}>
                  {originRooms.length > 0 ? originRooms.map((r) => r.name).join(', ') : t('common.none')}
                </span>
              </div>
            </div>

            <Grid useFormGap>
              <GridRow>
                <Input
                  name='comment'
                  label={t('common.comment')}
                  onChange={async (e) => setFieldValue('comment', e.target.value)}
                  value={values.comment}
                />
              </GridRow>
            </Grid>

            <ModalBottomButtons
              closeButton={{
                callback: () => {
                  onClose();
                  resetForm();
                },
              }}
              submitButton={{
                disabled: isSubmitting || !dirty,
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
